import { required } from 'vuelidate/lib/validators';
import { FundDetails } from '@/app/utils/constants/FundDetails';

const addressValid = value => (value.line1 !== '' && value.city !== '' && value.state !== '' && value.country !== '' && value.postal_code !== '' && value.postal_code.length >= 4);

export default {
  name: 'fund-details',
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    name: {
      get() {
        return this.$store.getters['fund/getFund'].details.name;
      },
      set(value) {
        this.$store.dispatch('fund/updateFundDetails', { name: value });
      },
    },
    hasExtendedFundDetails() {
      const type = this.$store.getters['toolkit/getItemType'];
      return FundDetails.includes(type);
    },
    address: {
      get() {
        return this.$store.getters['fund/getFund'].details.address || {
          line1: '',
          line2: '',
          city: '',
          state: '',
          country: 'Australia',
          postal_code: '',
        };
      },
      set(value) {
        this.$store.dispatch('fund/updateFundDetails', { address: value });
      },
    },
    contactNumber: {
      get() {
        return this.$store.getters['fund/getFund'].details.contactNumber || '';
      },
      set(value) {
        this.$store.dispatch('fund/updateFundDetails', { contactNumber: value });
      },
    },
  },
  methods: {
    handleContinueClick() {
      this.loading = true;
      this.$emit('nextStep');
    },
  },
  validations() {
    if (this.hasExtendedFundDetails) {
      return {
        address: {
          addressValid,
        },
        contactNumber: {
          required,
        },
        name: {
          required,
        },
      };
    }
    return {
      name: {
        required,
      },
    };
  },
};
